import React, { FunctionComponent } from 'react';
import { SvgIcon } from '@material-ui/core';

export const CalculatorIcon: FunctionComponent = () => {
  return (
    <SvgIcon viewBox="0 0 24.28 30" style={{ fill: 'currentColor' }}>
      <path
        d="M12.86,0h7.8a3.56,3.56,0,0,1,3.58,3,4.63,4.63,0,0,1,0,.65q0,11.36,0,22.72a3.53,3.53,0,0,1-3,3.6,4.17,4.17,0,0,1-.71,0H3.74A3.53,3.53,0,0,1,.3,27.84a5.55,5.55,0,0,1-.24-.69L0,25.72V3.9A5.4,5.4,0,0,1,.08,2.83,3.54,3.54,0,0,1,3.64,0h9.22Zm10,15V3.74a2.15,2.15,0,0,0-2.31-2.31H3.75A2.92,2.92,0,0,0,3,1.51a2.16,2.16,0,0,0-1.6,2.28V26.23a2.68,2.68,0,0,0,.08.7,2.11,2.11,0,0,0,2.14,1.65h17a2.57,2.57,0,0,0,.55-.06,2.15,2.15,0,0,0,1.68-2.24Z"
        transform="translate(0 0)"
      />
      <path
        d="M12.12,12.86H6.61A3.6,3.6,0,0,1,2.86,9.28c0-1.07,0-2.16,0-3.23a3.38,3.38,0,0,1,2.43-3,4.71,4.71,0,0,1,1.45-.2c3.59,0,7.17,0,10.76,0a3.73,3.73,0,0,1,3.13,1.42,3.35,3.35,0,0,1,.75,2.13c0,1.13,0,2.26-.05,3.39a3.46,3.46,0,0,1-2.31,2.86,6.38,6.38,0,0,1-1.57.21C15.7,12.88,13.91,12.86,12.12,12.86Zm0-1.45c1.89,0,3.79,0,5.68,0A2.17,2.17,0,0,0,20,9.3c0-1,0-2,0-2.93a2.17,2.17,0,0,0-2.14-2.09q-5.71,0-11.44,0A2.16,2.16,0,0,0,4.29,6.46c0,.91,0,1.81,0,2.71a2.22,2.22,0,0,0,2.25,2.26C8.4,11.38,10.27,11.41,12.14,11.41Z"
        transform="translate(0 0)"
      />
      <path
        d="M21.43,20.71c0,1.18,0,2.36,0,3.54a2.86,2.86,0,1,1-5.71,0c0-2.35,0-4.71,0-7.06A2.83,2.83,0,0,1,20,14.69a2.73,2.73,0,0,1,1.43,2.53C21.45,18.38,21.43,19.54,21.43,20.71Zm-4.29,0h0c0,1.19,0,2.38,0,3.57a1.42,1.42,0,0,0,1.47,1.42A1.45,1.45,0,0,0,20,24.18V17.27a2,2,0,0,0-.06-.48,1.42,1.42,0,0,0-1.74-1,1.44,1.44,0,0,0-1.06,1.51C17.14,18.43,17.14,19.58,17.14,20.73Z"
        transform="translate(0 0)"
      />
      <path
        d="M12.13,27.15a2.86,2.86,0,0,1,0-5.72,2.86,2.86,0,1,1,0,5.72Zm0-4.28a1.43,1.43,0,1,0,0,2.85,1.43,1.43,0,0,0,1.41-1.41A1.41,1.41,0,0,0,12.15,22.87Z"
        transform="translate(0 0)"
      />
      <path
        d="M8.56,24.31a2.85,2.85,0,1,1-2.83-2.88A2.84,2.84,0,0,1,8.56,24.31Zm-1.43,0a1.42,1.42,0,1,0-2.84,0,1.42,1.42,0,1,0,2.84,0Z"
        transform="translate(0 0)"
      />
      <path
        d="M12.18,14.3a2.85,2.85,0,1,1-2.89,2.75A2.86,2.86,0,0,1,12.18,14.3Zm0,1.42a1.43,1.43,0,1,0,0,2.86,1.43,1.43,0,0,0,0-2.86Z"
        transform="translate(0 0)"
      />
      <path
        d="M8.56,17.13A2.85,2.85,0,1,1,5.69,14.3,2.84,2.84,0,0,1,8.56,17.13Zm-1.43,0A1.42,1.42,0,1,0,5.7,18.58,1.43,1.43,0,0,0,7.13,17.15Z"
        transform="translate(0 0)"
      />
    </SvgIcon>
  );
};

export default CalculatorIcon;
